// Crawlable language routes for the public (marketing) site.
//   Arabic  -> /            /features        /pricing
//   English -> /en          /en/features     /en/pricing
//   French  -> /fr          /fr/features     /fr/pricing
//
// Arabic is the default language and therefore has no prefix.

export const MARKETING_LANGS = ["ar", "en", "fr"] as const;
export type MarketingLang = (typeof MARKETING_LANGS)[number];

export const LANG_PREFIX: Record<MarketingLang, string> = {
  ar: "",
  en: "/en",
  fr: "/fr",
};

/** Split "/en/pricing" into { lang: "en", basePath: "/pricing" }. */
export function splitLangPath(pathname: string): { lang: MarketingLang; basePath: string } {
  const match = /^\/(en|fr)(\/.*)?$/i.exec(pathname || "/");
  if (match) {
    return { lang: match[1].toLowerCase() as MarketingLang, basePath: match[2] || "/" };
  }
  return { lang: "ar", basePath: pathname || "/" };
}

/** Build the localized URL path for a language-neutral path. */
export function withLang(basePath: string, lang: MarketingLang): string {
  const p = !basePath ? "/" : basePath.startsWith("/") ? basePath : `/${basePath}`;
  if (lang === "ar") return p;
  return p === "/" ? LANG_PREFIX[lang] : `${LANG_PREFIX[lang]}${p}`;
}

/** Normalize any i18n language code to a marketing language (ur/other -> ar). */
export function toMarketingLang(code?: string | null): MarketingLang {
  const base = (code || "ar").split("-")[0].toLowerCase();
  return (MARKETING_LANGS as readonly string[]).includes(base) ? (base as MarketingLang) : "ar";
}
